<template>
	<div :class="['reply-item', itemHide ? 'f-dn' : '' ]">
		<a 
			href="javascript:void(0);" 
			class="open-btn" 
			v-if="openBtnShow"
			@click="openReplyHandle">
			展开{{count - 3}}条回复<span class="icon-arrow"></span>
		</a>
		<reply-top-bar :item="item"></reply-top-bar>
		<item-content :item="item" :hide="itemHide"></item-content>
	</div>
</template>

<script>
import imgMixin from 'mixins/image'	
import ReplyTopBar from './reply-top-bar'
import ItemContent from './item-content'
export default {
	mixins: [imgMixin],
	components: {
		ReplyTopBar,
		ItemContent
	},
	props: {
		item: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		count: {
			type: Number,
			required: true
		},
		openReplyStatus: {
			type: Boolean,
			required: true
		},
		openReplyHandle: {
			type: Function,
			required: true
		}
	},
	computed: {
		itemHide() {
			if(this.index > 1 && this.index < (this.count - 1) && !this.openReplyStatus) {
				return true;
			}
			return false;
		},
		openBtnShow() {
			if(this.index === (this.count - 1) && this.index > 2 && !this.openReplyStatus) {
				return true;
			}
			return false;
		}
	}
}	
</script>


// WEBPACK FOOTER //
// reply-item.vue?0f08ca95